import { createStore } from 'vuex';
import themeLayout from './modules/themeLayout/actionCreator';
import gallery from './modules/gallery';
import users from './modules/users';
import chartContent from './modules/chartContent/actionCreator';
import email from './modules/email/actionCreator';
import headerSearchData from './modules/headerSearch/actionCreator';
import chat from './modules/chat/actionCreator';
import ecommerce from './modules/ecommerce/product/actionCreator';
import orders from './modules/orders/actionCreator';
import cart from './modules/ecommerce/cart/actionCreator';
import profile from './modules/profile/actionCreator';
import project from './modules/project/actionCreator';
import calendar from './modules/calendar/actionCreator';
import team from './modules/team/actionCreator';
import contact from './modules/contact/actionCreator';
import note from './modules/note/actionCreator';
import todo from './modules/todo/actionCreator';
import task from './modules/task/actionCreator';
import crud from './modules/crud/axios/actionCreator';
import auth from './modules/authentication/actionCreator';
import KanbanBoard from './modules/kanban/actionCreator';
import product from './modules/omni/actionCreator';
import customers from './modules/customers/actionCreator';
import storeviews from './modules/storeviews/actionCreator';
import clients from './modules/clients/actionCreator';
import enquiries from './modules/enquiries/actionCreator';
import appointments from './modules/appointments/actionCreator';
import marketing from './modules/marketing/actionCreator';
import reporting from './modules/report/actionCreator';
import { createLogger } from 'vuex';

export default createStore({
  modules: {
    themeLayout,
    gallery,
    users,
    chartContent,
    email,
    headerSearchData,
    chat,
    ecommerce,
    cart,
    profile,
    project,
    calendar,
    team,
    contact,
    note,
    todo,
    task,
    crud,
    auth,
    KanbanBoard,
    orders,
    omni: product,
    customers,
    storeviews,
    clients,
    enquiries,
    appointments,
    marketing,
    reporting,
  },
  plugins: [createLogger()],
});
